import { EMBEDDED_APPRAISAL_FLOW_EXPERIMENT } from '~/constants/common/embeddedAppraisalFlow';
import { HOME_APP_ROUTER_EXPERIMENT } from '~/constants/common/homeAppRouter';
import { OPEN_TEXT_SEARCH_EXPERIMENT } from '~/constants/common/openTextSearch';
import { PRICE_DROP_SUPPRESSION_EXPERIMENT } from '~/constants/common/priceDropSuppression';
import { SHAQ_HOME_TAKEOVER_EXPERIMENT } from '~/constants/common/shaqHomeTakeover';

export const clientSideBrowserCookieIdExperiments = {};

export const serverSideBrowserCookieIdExperiments = {
  [HOME_APP_ROUTER_EXPERIMENT]: {},
  [OPEN_TEXT_SEARCH_EXPERIMENT]: {},
  [PRICE_DROP_SUPPRESSION_EXPERIMENT]: {},
  [SHAQ_HOME_TAKEOVER_EXPERIMENT]: {}
};

export const clientSideUserIdExperiments = {
  [EMBEDDED_APPRAISAL_FLOW_EXPERIMENT]: {}
};

export const serverSideUserIdExperiments = {};

export const clientSideExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments
};

export const serverSideExperiments = {
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const browserCookieIdExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...serverSideBrowserCookieIdExperiments
};

export const userIdExperiments = {
  ...clientSideUserIdExperiments,
  ...serverSideUserIdExperiments
};

export const experiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments,
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const experimentNames = Object.keys(experiments);
